import { useReactiveVar } from '@apollo/client';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import type React from 'react';
import styles from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/ShowMetadataSwitch/ShowMetadataSwitchStyles';
import viewStateVar from 'src/store/viewState';

export default function ShowMetadataSwitch(): React.ReactElement {
  const classes = styles();
  const viewState = useReactiveVar(viewStateVar);

  function showMetaDataToggle(): void {
    viewStateVar({
      ...viewStateVar(),
      showMetadata: !viewStateVar().showMetadata,
    });
  }

  return (
    <FormControlLabel
      classes={{ root: classes.showMetadataSwitch }}
      value="end"
      control={<Switch checked={viewState.showMetadata} onClick={showMetaDataToggle} />}
      label="Show Metadata"
      labelPlacement="end"
    />
  );
}
